export default __webpack_public_path__ + "static/product-photo-2f246085f06823332f2f642328dbacd2.png";